export class PaymentRequiredError extends Error {
  public paymentDetails: string | null;
  public response: Response;

  constructor(response: Response, paymentDetails: string | null) {
    super("Payment required");
    this.name = "PaymentRequiredError";
    this.paymentDetails = paymentDetails;
    this.response = response;
  }
}

export async function apiFetch(path: string, options: RequestInit = {}) {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(options.headers as Record<string, string>),
  };
  const res = await fetch(`/api${path}`, {
    ...options,
    headers,
    credentials: "include",
  });

  if (res.status === 402) {
    throw new PaymentRequiredError(res, res.headers.get("X-PAYMENT-REQUIRED"));
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error((err as any).error || res.statusText);
  }
  return res.json();
}
